import { ValidationProps, ValidationLevel } from 'ui';

export const mapValidation = (validation: { [key: string]: ValidationProps },
  fieldId: number,
  formName: string,
  fieldGroupingName: string): ValidationProps => {

  const validationMessages = validation && validation[formName] && validation[formName].messages
    && validation[formName].messages.filter(
      message => message.parameters && message.parameters[fieldGroupingName] &&
        message.parameters[fieldGroupingName] === fieldId);

  return validationMessages && { level: ValidationLevel.error, messages: validationMessages } || undefined;
};

export const mapInvalidOptions = (validationProps: ValidationProps, valueName: string) => {
  return validationProps && validationProps.messages && validationProps.messages
    .map(message => message && message.parameters && message.parameters[valueName])
    .filter(value => !!value || value === 0)
    .map(value => ({
      value
    })) || [];
};
